import Konva from 'konva/konva'
import YScaleLabel from './y-scale-label'
import { translateVariableValue } from '../../helpers/translation'

export default class CategoryVariableScale extends Konva.Group {
  constructor ({ width, yFrom, yTo, values }) {
    super({ width })
    Object.assign(this, { yFrom, yTo, values })

    this._render()
  }

  _render () {
    const { yFrom, yTo, values } = this
    const scaleWidth = this.width()
    if (values.length >= 2) {
      const step = (yTo - yFrom) / (values.length - 1)
      values.forEach((value, index) => {
        this.add(new YScaleLabel({
          scaleWidth,
          y: yFrom + step * (values.length - 1 - index),
          text: translateVariableValue(value)
        }))
      })
    }
  }
}
